import {
  defineNuxtPlugin,
  navigateTo,
  addRouteMiddleware,
} from 'nuxt/app'
import {
  firebaseUser,
  isUserLoaded,
  initUser,
} from '~/composables/useFirebase'
import { NuxtRoutes } from '~/constants/routes'

export default defineNuxtPlugin(() => {
  addRouteMiddleware('auth', async () => {
    if (!isUserLoaded.value) {
      await initUser()
    }

    if (!firebaseUser.value) {
      $log('User not logged in, redirecting to login page.')
      return navigateTo({ name: NuxtRoutes.AuthLogin })
    }
  })
})
